import React, { useEffect } from 'react';
import './Boarding.css';
import usePageTitle from '../hooks/usePageTitle';
import { useLanguage } from '../hooks/useLanguage';
import borderImage from '../assets/border.png';
import boardingLeft from '../assets/boarding_left.png';
import boardingRight from '../assets/boarding_right.png';

const Boarding: React.FC = () => {
  const { t } = useLanguage();
  usePageTitle(t('boarding.title'));
  
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Remove animation classes first to reset
    const allElements = document.querySelectorAll('.boarding-title, .boarding-subtitle, .boarding-description');
    allElements.forEach(element => {
      element.classList.remove('animate-in-initial');
    });
    
    // Force reflow to ensure the removal is processed
    void document.body.offsetHeight;
    
    // Animate initial content on page load
    // Title animates first
    const titleElement = document.querySelector('.boarding-title');
    if (titleElement) {
      setTimeout(() => {
        titleElement.classList.add('animate-in-initial');
      }, 200);
    }
    
    // Subtitle animates after title
    const subtitleElements = document.querySelectorAll('.boarding-subtitle');
    setTimeout(() => {
      subtitleElements.forEach(element => {
        element.classList.add('animate-in-initial');
      });
    }, 210);
    
    // Description animates 200ms after subtitle
    const descriptionElements = document.querySelectorAll('.boarding-description');
    setTimeout(() => {
      descriptionElements.forEach(element => {
        element.classList.add('animate-in-initial');
      });
    }, 410);
  }, []);
  return (
    <div className="boarding-page">
      <div className="boarding-container">
        <h1 className="boarding-title">{t('boarding.title')}</h1>
        <img src={borderImage} alt="" className="boarding-decorative-line" />

        <div className="boarding-left-images">
          <img src={boardingLeft} alt="Boarding schools" className="boarding-side-image" />
        </div>

        <div className="boarding-content-wrapper">
          <div className="boarding-content">
            <h2 className="boarding-subtitle">
              <em><strong>Experientia Docet.</strong></em> {t('boarding.subtitle').split('.').slice(1).join('.').trim()}
            </h2>

            <p className="boarding-description">
              {t('boarding.description')}
            </p>
          </div>
        </div>

        <div className="boarding-right-images">
          <img src={boardingRight} alt="Boarding schools" className="boarding-side-image" />
        </div>
      </div>
    </div>
  );
};

export default Boarding;